import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export type AlertSeverity = 'error' | 'warning' | 'info' | 'success';
export const severityConfig: Record<
  AlertSeverity,
  {
    icon: typeof ErrorOutlineIcon;
    color: 'error' | 'warning' | 'info' | 'success';
  }
> = {
  error: { icon: ErrorOutlineIcon, color: 'error' },
  warning: { icon: WarningAmberIcon, color: 'warning' },
  info: { icon: InfoOutlinedIcon, color: 'info' },
  success: { icon: CheckCircleOutlineIcon, color: 'success' },
};
